import { Injectable } from '@angular/core';
import { isTTCodeInvalidViaRegex } from 'shared/ui-common';

import {
  Guideline,
  validateFlowchartWidget,
  ChapterWidget,
  GuidelineWidget,
  validateChapterWidget,
  GuidelineValidationResult,
  validateComponentListWidget,
} from '@treetop/shared/model';

@Injectable({ providedIn: 'root' })
export class GuidelineValidatorService {
  public validate(guideline: Guideline): GuidelineValidationResult {
    const title = guideline.title?.trim();
    if (!title || title.length === 0) {
      return {
        valid: false,
        message: 'GuidelineTitleMissing',
      };
    }

    if (!guideline.code || isTTCodeInvalidViaRegex(guideline.code)) {
      return {
        valid: false,
        message: 'GuidelineCodeMissing',
      };
    }

    if (!guideline.code || isTTCodeInvalidViaRegex(guideline.code)) {
      return {
        valid: false,
        message: 'TemplateCodeMissing',
      };
    }

    return this.validateGuidelineChapters(guideline.chaptersWidgetIds, guideline.widgetMap);
  }

  private validateGuidelineChapters(chapterIds: string[], widgetMap: Record<string, GuidelineWidget>): GuidelineValidationResult {
    if (!chapterIds || chapterIds.length === 0) {
      return {
        valid: true,
        message: '',
      };
    }

    const chapters = chapterIds.map((id) => widgetMap[id] as ChapterWidget).filter((widget) => widget != null);

    for (const chapter of chapters) {
      const validation = validateChapterWidget(chapter);
      if (!validation.valid) {
        return validation;
      }

      if (chapter.widgetIds?.length > 0) {
        const widgets = chapter.widgetIds?.map((widgetId) => widgetMap[widgetId]).filter(Boolean) ?? [];

        for (const widget of widgets) {
          let widgetValidation;

          switch (widget.widgetType) {
            case 'component-list':
              widgetValidation = validateComponentListWidget(widget, { title: chapter.title }, widgetMap);
              break;
            case 'flowchart':
              widgetValidation = validateFlowchartWidget(widget, {
                chapter: { title: chapter.title },
              });
              break;
            default:
              widgetValidation = {
                valid: true,
                message: '',
              };
          }

          if (!widgetValidation.valid) {
            return widgetValidation;
          }
        }
      }

      if (chapter.childrenIds?.length > 0) {
        const areChildrenValid = this.validateGuidelineChapters(chapter.childrenIds, widgetMap);
        if (!areChildrenValid.valid) {
          return areChildrenValid;
        }
      }
    }

    return {
      valid: true,
      message: '',
    };
  }
}
